import { useEffect, useState } from "react";
import dayjs from '../utils/dayjs-setup';
import { AxiosInstance, DateFormatString, IsBeforeNowDate, getCalculateEntregaData } from "../utils/constants";

const PedidosMaker = (checkout = [])=>{

    let itemsByCentroOpe = [];
    let newCheckout  = checkout.map( item=>({
        ...item.producto,
        cantidad:item.cantidad
    } ));
    newCheckout.forEach( item =>{
       const existIndex = itemsByCentroOpe.findIndex( item_cp => item_cp.codigo_cp === item.cod_cp );
       if ( existIndex !== -1 ){
        itemsByCentroOpe[existIndex]["items"].push(
            item
        );
       }else{
        itemsByCentroOpe.push({
            "codigo_cp":item.cod_cp,
            "items":[
                item
            ]
        });
       }
    });

    return itemsByCentroOpe;

}

const calCulateDiscountProduct = (prod,configClient)=>{
    let discount = 15;
    if ( prod.ind_sync_automatica !== 'SI'){
        return 0;
    }
    
    if (configClient.tipo_pedido === 'COTIZACION'){
        discount = 20;

        if ( ["EF","TE"].includes(configClient?.medio_pago?.descripcion_corta)){
            discount += 10;
        }
        if ( ["RT"].includes(configClient?.typeService?.value)){
            discount += 20;
        }
    }else{
     
        if ( configClient.typeService?.value === 'RT' ){
            discount += 10;
        }

        if ( ["EF","TE"].includes(configClient?.medio_pago?.descripcion_corta)){
            discount  += 10;
        }

    }
   const margen_with_desc = Number(prod.margen_objetivo)*(discount/100);
   const priceDiscount = Math.round( Number(prod.precio_base)*(100/(100-( Number(prod.margen_objetivo) -  margen_with_desc   )  )) );
   const priceDiscountImp = priceDiscount + (priceDiscount * (Number(prod.impuesto_prod)/100) );
   return Number( (Number( prod.precio_venta  ) -  priceDiscountImp).toFixed(2) );

}

export const ConverProductoValues = (prod,config_client)=>{
    let prodClone = {...prod};
    const cantidad = Number(prod.cantidad);
    prodClone.discount = calCulateDiscountProduct({...prod},config_client);
    prodClone.total_discount = prodClone.discount * cantidad;
    prodClone.subtotal_price = ( Number( prod.precio_venta ) * cantidad );
    prodClone.total_price = ( (Number( prod.precio_venta ) - prodClone.discount  ) * cantidad );
    prodClone.valor_impuesto =   Number(prod.impuesto_prod) > 0 ? (Number( prod.precio_venta ) - prodClone.discount  ) / (1+(  Number(prod.impuesto_prod)/100 )):0; 
    prodClone.precio_venta_final =  Number(prod.precio_venta ) - prodClone.discount;

    return prodClone;
}





export const useCalculatePedido = ()=>{
    const [total_valor_pedido,setTotalValorPedido] = useState(0);
    const [costo_servicio,setCostoServicio] = useState(0);
    const [checkoutList,setCheckoutList] = useState([]);
    const [total_descuento,setTotalDescuento] = useState(0);
    const [centro_operacion_seleccionado,setCentroOperacionSeleccionado] = useState(0);
    const [itemsByCentrosOpe,setItemsByCentrosOpe] = useState([]);
    const [configClient,setconfigClient] = useState({});


    useEffect(()=>{
         
        if (Object.keys(configClient).length > 2){
            runCalculateRequest();
           
        }
    },[configClient]);



  


    const runCalculateRequest = (localeconfig=null)=>{
        const actualConfig = localeconfig || configClient;
        const cartCheckout = [...actualConfig.items_added || actualConfig.items_added || []];
        let centro_operacion_recogida = null;
        let total_costo_servicio = 0;
        let total_valor_pedido = 0;
        let total_descuento = 0;
        let newCheckout = [];
        var itemsByCentrosOpe = JSON.parse( JSON.stringify(PedidosMaker( cartCheckout  )) );
        itemsByCentrosOpe.forEach( (item_checkout_cp,index_item_checkout_cp) =>{
            let sumCosto_servicio = 0 ;
            let sumCosto_mercancia  = 0 ;
            let sumDiscount = 0;
            let Servicio = actualConfig.typeService;
            const tope_servicio = Servicio?Number(Servicio.valor_maximo):0;
            if ( !Servicio){
                Servicio = {
                    valor:0,
                    valor_maximo:0
                };
            }
            item_checkout_cp.servicio = Servicio;
            
            item_checkout_cp.items.forEach( (item_check,index_item_check)=>{
               
                const costo_envio = ((  Number(  item_check.peso ) * Number(item_check.cantidad)  ) * Number(Servicio?.valor || 0) );
                const prod_res = {...ConverProductoValues( item_check,actualConfig )};
                itemsByCentrosOpe[index_item_checkout_cp].items[index_item_check] = {...prod_res};

                itemsByCentrosOpe[index_item_checkout_cp].items[index_item_check].servicio = Servicio;
                itemsByCentrosOpe[index_item_checkout_cp].items[index_item_check].costo_servicio =  costo_envio;
                sumCosto_servicio += costo_envio;
                total_descuento += prod_res.total_discount;
                sumDiscount += total_descuento;
                sumCosto_mercancia += prod_res.total_price;
            });
            total_valor_pedido += sumCosto_mercancia;
            if ( (tope_servicio > sumCosto_servicio )){
                sumCosto_servicio = tope_servicio;
                //redistribuir el costo del domicilio por el tope
                
            }

          
            sumCosto_servicio = tope_servicio;

            itemsByCentrosOpe[index_item_checkout_cp].sum_costos = sumCosto_mercancia;
            itemsByCentrosOpe[index_item_checkout_cp].sum_service = sumCosto_servicio;
            itemsByCentrosOpe[index_item_checkout_cp].sum_discount = sumDiscount;
        } );


         total_costo_servicio = itemsByCentrosOpe.reduce( (counter,item)=>{
             newCheckout = newCheckout.concat(item.items);
            return counter + item.sum_service;
         },0);

         total_valor_pedido  = total_valor_pedido;
        setItemsByCentrosOpe(itemsByCentrosOpe);
        setCentroOperacionSeleccionado(centro_operacion_recogida);
        setCheckoutList( newCheckout );
        setCostoServicio(total_costo_servicio);
        setTotalValorPedido(total_valor_pedido);
        setTotalDescuento( total_descuento );

        return {
            cartCheckout:newCheckout,
            total_valor_pedido:total_valor_pedido + total_costo_servicio,
            valor_pedido:total_valor_pedido,
            costo_servicio:total_costo_servicio,
            total_descuento:total_descuento,
            itemsByCentrosOpe,
            setconfigClient
            
        }

    }


    return {
        cartCheckout:checkoutList,
        total_valor_pedido:total_valor_pedido + costo_servicio,
        valor_pedido:total_valor_pedido,
        costo_servicio,
        total_descuento,
        centro_operacion_seleccionado,
        itemsByCentrosOpe,
        runCalculateRequest,
        setconfigClient
    }


}





export const CalculateBodyRequestCheckout = (list_cp_items = [],sucursal_cl,fecha_servicio = {},dataform,total_valor_pedido,tipos_entregas=[],configCliente)=>{
    const tipo_entrega_seleccionada = tipos_entregas.find(te=>te.value == dataform.tipo_entrega);
    console.log({tipo_entrega_seleccionada,dataform,configCliente});
    let payloadList = [];
    list_cp_items.forEach((cp_item,cp_item_index) =>{

        cp_item.items.forEach( (item,index)=>{
            let customDate = null;
            if (item.es_especial === 'SI'){
              customDate =  IsBeforeNowDate( item.fecha_minima_oferta  )?fecha_servicio[configCliente.typeService.value]:item.fecha_minima_oferta;
            }else{
              customDate =  fecha_servicio[configCliente.typeService.value];
            }
            list_cp_items[cp_item_index].items[index].fecha_entrega = customDate;
        } );
    const generaLidates = getCalculateEntregaData(cp_item.items);
    console.log("ls list",cp_item.items,configCliente);
    let payload_form = {
                cod_pedido:dataform.cod_pedido,
                persona_contacto:dataform.persona_contacto,
                cod_centro_operacion:cp_item.codigo_cp,
                fecha_pedido:dayjs().format(DateFormatString),
                fecha_entrega:generaLidates.min,
                cod_sucursal_cliente:null,
                punto_envio:sucursal_cl.cod,
                cod_municipio_entrega:sucursal_cl.cod_municipio,
                cod_tipo_entrega:tipo_entrega_seleccionada.cod_tipo_servicio,
                cod_servicio:tipo_entrega_seleccionada.cod_servicio,
                costo_servicio:cp_item.sum_service,
                fecha_recogida:fecha_servicio[dataform.tipo_entrega],
                numero_dias_entrega:generaLidates.num_days,
                sub_total:cp_item.sum_costos,
                vlr_neto:total_valor_pedido,
                tipo_pedido:dataform.tipo_pedido,
                medio_pago:dataform.medio_pago.value, // se debe consultar en base de datos 
                condicion_pago:dataform.medio_pago.descripcion_corta !== 'CR'?dataform.medio_pago.cod_erp:dataform.tipo_credito,
                numero_dias_entrega:3,
                is_admin:true,
                detalle:cp_item.items.map( (item_list,item_index)=>({
                    cod_detalle_pedido:item_list.cod_detalle_pedido,
                    cod_producto:item_list.cod_producto,
                    cod_unidad_medida:item_list.cod_unidad_medida,
                    cantidad:item_list.cantidad,
                    observaciones:dataform.productos_list[item_index].observaciones,
                    precio_unitario:item_list.precio_venta,
                    vlr_subtotal:item_list.subtotal_price,
                    vlr_total:item_list.total_price,
                    vlr_impuestos:item_list.valor_impuesto,
                    vlr_neto:item_list.precio_venta_final,
                    fecha_entrega:generaLidates.min,
                    cod_oferta:item_list.cod_oferta,
                    vlr_descuentos:item_list.discount
                })  )
            }
        
        payloadList.push( payload_form );
    
    });
    
/*     console.log({
        payloadList,
        list_cp_items,
        sucursal_cl,
        fecha_servicio,
        tipo_servicio
    }); */

    return payloadList;

}

export {
    calCulateDiscountProduct
}